"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignmentEnum = void 0;
var AlignmentEnum;
(function (AlignmentEnum) {
    AlignmentEnum["Center"] = "center";
    AlignmentEnum["Left"] = "left";
    AlignmentEnum["Right"] = "right";
})(AlignmentEnum = exports.AlignmentEnum || (exports.AlignmentEnum = {}));
